import { render } from "./ForgottenPassword.vue?vue&type=template&id=1a29b264"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"

import "./ForgottenPassword.vue?vue&type=style&index=0&id=1a29b264&lang=css"
script.render = render

export default script